__turbopack_context__.v({
  "content": "InfoStrip-module-scss-module__66Hpra__content",
  "fade-in": "InfoStrip-module-scss-module__66Hpra__fade-in",
  "logotype": "InfoStrip-module-scss-module__66Hpra__logotype",
  "no-transform": "InfoStrip-module-scss-module__66Hpra__no-transform",
  "rotate": "InfoStrip-module-scss-module__66Hpra__rotate",
  "strip": "InfoStrip-module-scss-module__66Hpra__strip",
});
